export default __webpack_public_path__ + "/dist/images/9037340.24b7931aef17ec426cc20931c37dbb76.png";